/*
 * @Author: Dong
 * @Date: 2022-04-19 18:56:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-27 10:50:49
 */

import { SelectedVersionType, UpdateQueueType } from './types';

/**
 *
 * @param queues 任务
 * @param type 类型 local 本地上传  service 服务器选择
 * @param checkSupos 是否需要校验操作系统
 * @returns
 */
export const isFinishTask = (queues: SelectedVersionType | UpdateQueueType[], type: string, checkSupos: boolean) => {
  if (!queues || queues.length === 0) return false;

  // 本地上传，所有任务结束(成功、失败)，并且supos上传成功
  if (type === 'local') {
    return (
      (queues as UpdateQueueType[]).every((queue) => queue.status && ['success', 'failure'].includes(queue.status)) &&
      (checkSupos
        ? (queues as UpdateQueueType[]).some((queue) => queue.name === 'supos' && queue.status === 'success')
        : true)
    );
  }

  // 服务端选择
  return checkSupos ? Object.keys(queues).includes('supos') : Object.keys(queues).length !== 0;
};

export const installData = (
  data: any,
  type: string,
  hosts?: { [props: string]: string[] } | null,
  updateMethod?: { [props: string]: number },
) => {
  if (!data) return;
  const params = Object.keys(data).map((name) => {
    const host = hosts ? { hosts: hosts[name] } : {};
    return {
      name: name,
      archiveId: data[name],
      type: ['install', 'reinstall'].includes(type) ? 1 : 2,
      updateMethod: updateMethod ? updateMethod[name] : '',
      ...host,
    };
  });

  return params;
};
